export const RESTRICTED_ACCESS_TOOLTIP_TEXT = `You don't have enough permissions. Please reach out to your organization admins.`;
